import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import OtterLogo from './OtterLogo';

const Footer: React.FC = () => {
  return (
    <footer className="border-t border-border">
      <div className="mx-auto max-w-7xl px-6 py-12 md:px-12">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-4 md:gap-8">
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2">
              <OtterLogo className="h-8 w-8" />
              <span className="text-xl font-bold">hebe</span>
            </Link>
            <p className="text-gray-400">Your digital companion that thinks like you do.</p>
          </div>

          <div>
            <h3 className="mb-4 font-semibold">Company</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/trust" className="text-gray-400 transition-colors hover:text-foreground">
                  Trust Center
                </Link>
              </li>
              <li>
                <a
                  href="mailto:careers@ohhebe.us"
                  className="text-gray-400 transition-colors hover:text-foreground"
                >
                  Careers
                </a>
              </li>
              <li>
                <a
                  href="mailto:press@ohhebe.us"
                  className="text-gray-400 transition-colors hover:text-foreground"
                >
                  Press
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 font-semibold">Legal</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/privacy"
                  className="text-gray-400 transition-colors hover:text-foreground"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/cookies"
                  className="text-gray-400 transition-colors hover:text-foreground"
                >
                  Cookie Policy
                </Link>
              </li>
              <li>
                <a
                  href="mailto:legal@ohhebe.us"
                  className="text-gray-400 transition-colors hover:text-foreground"
                >
                  Legal Inquiries
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 font-semibold">Connect</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="mailto:hello@ohhebe.us"
                  className="flex items-center gap-2 text-gray-400 transition-colors hover:text-foreground"
                >
                  <Mail className="h-4 w-4" />
                  <span>Contact</span>
                </a>
              </li>
              {/* <li>
                <a 
                  href="https://twitter.com/ohhebe"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-gray-400 hover:text-foreground transition-colors"
                >
                  <Twitter className="w-4 h-4" />
                  <span>Twitter</span>
                </a>
              </li>
              <li>
                <a 
                  href="https://github.com/ohhebe"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-gray-400 hover:text-foreground transition-colors"
                >
                  <Github className="w-4 h-4" />
                  <span>GitHub</span>
                </a>
              </li> */}
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-border pt-8">
          <p className="text-center text-gray-400">
            © {new Date().getFullYear()} hebe. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
